import React, { useContext, useMemo } from 'react';
import { ContextType as DashboardContextType, DashboardContext } from 'contexts/DashboardContext';
import ProgressBar from 'common/components/ProgressBar';
import { getDisconnectedCount } from './getDisconnectedCount';

const NotConnected: React.FC = () => {
  const { sessions } = useContext<DashboardContextType>(DashboardContext);
  const progressBarData = useMemo(() => {
    const filteredSessions =
      sessions?.filter(
        (session) => !['completed', 'terminated'].includes(session.session_status),
      ) || [];
    if (!filteredSessions.length) {
      return [
        { label: 'Primary Device', color: 'red', value: '0', percentage: 0 },
        { label: 'Secondary Device', color: 'red', value: '0', percentage: 0 },
      ];
    }
    const { disconnectedPrimaryCamCount, disconnectedSecondaryCamCount } =
      getDisconnectedCount(filteredSessions);
    const total = filteredSessions.length || 1;
    const disconnectedPrimaryCamPercentage = Math.round(
      (disconnectedPrimaryCamCount / total) * 100,
    );
    const disconnectedSecondaryCamPercentage = Math.round(
      (disconnectedSecondaryCamCount / total) * 100,
    );
    return [
      {
        label: 'Primary Device',
        color: 'red',
        value: `${disconnectedPrimaryCamCount || 0}`,
        percentage: disconnectedPrimaryCamPercentage,
      },
      {
        label: 'Secondary Device',
        color: 'red',
        value: `${disconnectedSecondaryCamCount || 0}`,
        percentage: disconnectedSecondaryCamPercentage,
      },
    ];
  }, [sessions]);
  return (
    <div className="flex flex-col space-y-6 p-2">
      {progressBarData.map(({ label, color, value, percentage }) => (
        <ProgressBar key={label} label={label} color={color} value={value} percentage={percentage} />
      ))}
    </div>
  );
};

export default NotConnected;
